import _ from 'lodash';

let curriculum;
export const getCurriculum = () => curriculum;
export const setCurriculum = (c) => { curriculum = c; };

export const getLevelItems = (level) => {
  const levelItems =
    _.shuffle(curriculum[`level_${level}`])
      .map((question, i) => Object.assign(question, { originalIndex: i }));
  return levelItems;
};
